<script setup>
import { ref } from "vue";

const props = defineProps({
  news: {
    type: Array,
    default: [],
  },
});

const url = ref("");
</script>

<template>
  <div class="wrapper d-flex flex-direction-column w-100 gap-10">
    <a
      v-for="item in news"
      :href="item.newsURL"
      target="_blank"
      class="news-item p-5 br-10 cursor-pointer"
    >
      {{ item.newsHeadline }}
    </a>
  </div>
</template>

<style scoped>
.wrapper {
}

.news-item {
  border: 1px solid var(--an-gray);
}
</style>
